<template>
  <div class="progress-bar">
    <div class="progress-bar__background">
      <div class="progress-bar__complete" :style="`width: ${progress}%`"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: "ProgressBar",
  computed: {
    ...mapGetters([
      'activeDataList',
      'activeIndex'
    ]),
    progress: function() {
      if (this.activeDataList.length == 0) {
        return 0;
      }
      return ( (this.activeIndex+1) * 100 ) / this.activeDataList.length;
    }
  }
}
</script>
<style lang="scss" scoped>
  .progress-bar {
    background: transparent;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: rem(10);
    padding-left: rem(150);

    &__background {
      width: 100%;
      height: 100%;
    }

    &__complete {
      // width: 50%;
      height: 100%;
      background: #646464;
    }
  }
</style>
